import React, { JSX } from 'react';
import { Toast, ToastContainer } from 'react-bootstrap';
import styles from './NotificationToast.module.scss';
import { getStaticAssetPath } from '../../utils/global';

interface NotificationToastProps {
  title: string;
  message: string;
  show: boolean;
  delay?: number;
  onClose: () => void;
}

const NotificationToast = ({
  title,
  message,
  show,
  onClose,
  delay = 3000
}: NotificationToastProps): JSX.Element => (
  <ToastContainer className={styles.toastContainer}>
    <Toast
      show={show}
      onClose={onClose}
      autohide
      delay={delay}
      className={styles.customToast}
      animation={true}
    >
      <Toast.Header className={styles.toastHeader} closeButton={true}>
        <img src={getStaticAssetPath('/icons/check.svg')} alt='check icon' />
        <strong className={`${styles.toastTitle} me-auto`}>{title}</strong>
      </Toast.Header>
      <Toast.Body className={styles.toastBody}>{message}</Toast.Body>
    </Toast>
  </ToastContainer>
);

export default NotificationToast;
